import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import {
  FETCH_MOTORBIKE_MODELS,
  FETCH_MOTORBIKE_MODELS_FAILURE,
  FETCH_MOTORBIKE_MODELS_SUCCESS
} from 'src/redux/motorbikeModelsReducer'

interface Response {
  models: string[]
}

interface FetchMotorbikeModelsAction {
  payload: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMotorbikeModelsFlow(action: FetchMotorbikeModelsAction): Generator<any, void, any> {
  try {
    const response: Response = yield call(apiCall, {
      endpoint: '/api/v2/motorbike_models',
      method: GET,
      params: {
        brand_id: action.payload
      }
    })
    yield put(FETCH_MOTORBIKE_MODELS_SUCCESS(response.models))
  } catch (error) {
    yield put(FETCH_MOTORBIKE_MODELS_FAILURE())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMotorbikeModelsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MOTORBIKE_MODELS, FetchMotorbikeModelsFlow)
}
